import React, { useEffect, useState } from "react";
import axios from "axios";
import { useTranslation } from 'react-i18next';
import { Button } from "../../components/ui/button";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "../../components/ui/card";
import { useForm, Controller } from "react-hook-form";
import OtpInput from "react-otp-input";
import { useLocation, useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import { URL } from "../../lib/apis";
import Navbar from "../home/Navbar";
import Footer from "../home/Footer";

interface OtpFormInputs {
  otp_code: string;
}

const Otp = () => {
  const { t } = useTranslation();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isNavbarShrunk, setIsNavbarShrunk] = useState(false);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const userData = location.state; // 👈 récupération

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<OtpFormInputs>();

  console.log("userData", userData);


  // Gestion du scroll pour la navbar
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setIsNavbarShrunk(true);
      } else {
        setIsNavbarShrunk(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const onSubmit = async (data: OtpFormInputs) => {
    try {
      setLoading(true);
      const postData = {
        user_id: userData ? parseInt(userData.user_id) : 10,
        otp_code: data.otp_code,
      };

      const response = await axios.post(
        `${URL}/users/verify-otp`,
        postData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      localStorage.setItem("user", JSON.stringify(userData.user_id));

      localStorage.setItem("token", userData.token);

      localStorage.setItem("expiresInTime", JSON.stringify(userData.expiresInTime));
      console.log("Réponse API:", response.data);
      navigate("/");
      toast.success(t('otp.successMessage'));
    } catch (error: any) {
      console.error("Erreur lors de la soumission:", error);
      toast.error(error.response.data.error);
    } finally {
      setLoading(false);
    }
  };

  const handleNumericInput = (event: React.KeyboardEvent<HTMLInputElement>) => {
    const key = event.key;
    if (!/^\d$/.test(key)) {
      event.preventDefault();
    }
  };

  return (
    <div>
      <Navbar isSidebarOpen={isSidebarOpen}
        toggleSidebar={() => setIsSidebarOpen(!isSidebarOpen)}
        isShrunk={isNavbarShrunk} />
      <div className="flex flex-1 flex-col items-center mt-[100px] md:mt-[98px] justify-center min-h-screen bg-gray-100 gap-10">
        <Card className="w-[450px] h-[350px] shadow-lg rounded-lg bg-gray">
          <CardHeader>
            <div className="flex items-center justify-center">
              <CardTitle>{t('otp.verifyTitle')}</CardTitle>
            </div>
            <div className="flex items-center justify-start mt-10">
              <CardDescription>{t('otp.phoneNumber')}</CardDescription>
            </div>
            <div className="flex items-center justify-center mt-10 text-[#868889]">
              <CardDescription>
                {t('otp.otpSentMessage')}
              </CardDescription>
            </div>
          </CardHeader>

          <CardContent>
            <form
              onSubmit={handleSubmit(onSubmit)}
              className="flex flex-col items-center"
            >
              <Controller
                name="otp_code"
                control={control}
                defaultValue=""
                rules={{
                  required: t('otp.otpRequiredError'),
                  minLength: {
                    value: 6,
                    message: t('otp.otpLengthError')
                  }
                }}
                render={({ field: { onChange, value } }) => (
                  <OtpInput
                    value={value}
                    onChange={onChange}
                    numInputs={6}
                    inputStyle={{
                      width: "2.5rem",
                      height: "3rem",
                      margin: "0.5rem",
                      fontSize: "1.5rem",
                      borderRadius: 4,
                      border: "1px solid #ccc",
                    }}
                    renderInput={(props) => (
                      <input {...props} onKeyDown={handleNumericInput} />
                    )}
                  />
                )}
              />
              {errors.otp_code && (
                <span className="text-red-500">{errors.otp_code.message}</span>
              )}

              <Button
                type="submit"
                className="mt-4 text-white bg-green-500 hover:bg-green-600 rounded-full py-2 px-4"
                disabled={loading}
              >
                {loading ? t('otp.sending') : t('otp.nextButton')}
              </Button>
            </form>
          </CardContent>
        </Card>
        <ToastContainer />
      </div>
      <div className="w-full">
        <Footer />
      </div>
    </div>

  );
};

export default Otp;